// src/styles.js

export const tokens = {
  colors: {
    primary: "#327b5fff",    // Ayurmax Primary (Teal)
    secondary: "#2d6b63",    // Ayurmax Light
    dark: "#1a3f3a",         // Ayurmax Dark
    lime: "#ccff00",         // Fresh Lime
    danger: "#d63031",
    success: "#4a6741",
    white: "#ffffff",
    black: "#000000",
    brownOne: "#5D4037",     // Earthy Brown for gradients
    brownTwo: "#8D6E63",     // Lighter Earthy Brown for gradients
  },
  fonts: {
    main: "'Inter', 'Segoe UI', sans-serif",
    serif: "'Playfair Display', 'Georgia', serif", // For those futuristic headings
  }
};

export const lightTheme = {
  body: "#f7fee7",          // Lime-50
  text: "#1a3f3a",          // Ayurmax Dark
  textSecondary: "#4b5563", // Gray-600
  card: "#ffffff",
  border: "#327b5fff",      // Ayurmax Primary
  inputBg: "#ffffff",
  ...tokens.colors,
};

export const darkTheme = {
  body: "#1a3f3a",          // Ayurmax Dark
  text: "#ffffff",
  textSecondary: "#d1d5db", // Gray-300
  card: "#111827",          // Gray-900 (Tailwind dark bg)
  border: "#4b5563",        // Gray-600
  inputBg: "#1f2937",       // Gray-800
  accent: "#b3e600",        // Fresh-300 (Lime accent for dark mode)
  ...tokens.colors,
};